import events from '../../events.yaml';
export const cloneTracker = (trackerInstance, usageTrackerLocation) => {
  return trackerInstance.clone({
    events,
    standalone: false,
    preserveTrackerProperties: false,
    trackerName: 'ai-components-ui-library',
    properties: {
      screen: usageTrackerLocation
    }
  });
};
export const cloneStandaloneTracker = (trackerInstance, usageTrackerLocation) => {
  return trackerInstance.clone({
    standalone: true,
    preserveTrackerProperties: false,
    trackerName: 'ai-components-ui-library',
    properties: {
      screen: usageTrackerLocation
    }
  });
};